export default __webpack_public_path__ + "media/src/assets/images/dock-60cbceb1f292464b20460ffc35e18589.png";